import React from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { GoBack } from "../../../components/Layout/GoBack";
// If you are using routing, you might need: import { useNavigate } from "react-router-dom";
// import { GoBack } from "../../../components/Layout/GoBack";
// import { BottomNav } from "../../../components/Nav/BottomNav";

const Refer = () => {
  const websiteURL = "https://africastrusteddigitalplatform.com/signup?refId=";

  const { user } = useSelector((state) => {
    // Safely default if state isn't populated yet
    const userData = state?.userData || {};
    return {
      user: userData.user || {},
    };
  });

  // Fallback referral link for visual testing if user data isn't loaded
  const fullReferralLink = `${websiteURL}${user?.referralLink || "667e7a15d26c7669e6403b18"}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(fullReferralLink);
    toast.success("Referral link copied", {
      duration: 3000,
      position: "bottom-center",
    });
  };

  return (
    /* 
      Locked to w-[1024px] to perfectly match the wide proportions of the design.
      This will scale down on mobile browsers if the viewport meta tag is set correctly.
    */
    <div className="w-[1024px] mx-auto bg-[#f8faff] min-h-screen relative font-sans text-slate-900 pb-24 shadow-[0_0_50px_rgba(0,0,0,0.05)] overflow-hidden">
      {/* --- Background Faint Map --- */}
      <div
        className="absolute top-0 right-0 w-[400px] h-[400px] bg-no-repeat bg-right-top rounded-full  mix-blend-multiply pointer-events-none"
        style={{
          backgroundImage: "url('/img/new/background/reward.jpeg')",
          backgroundSize: "contain",
        }}
      ></div>

      {/* <div className="relative z-10 px-12 pt-12 pb-6">
        <button className="flex items-center gap-2 text-[#1a4bdf] font-medium text-[17px] bg-white px-5 py-2.5 rounded-full shadow-sm border border-gray-100 hover:bg-gray-50 transition-colors active:scale-95 cursor-pointer">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Back
        </button>
      </div> */}

      <GoBack />

      <div className="px-12 relative z-10 flex flex-col gap-8">
        {/* --- Hero Section --- */}
        <div className="flex items-center justify-between">
          <div className="w-[55%] pr-8">
            <h1 className="text-[3.5rem] font-semibold text-[#071330] leading-tight mb-6">
              Referral Program
            </h1>
            <div className="space-y-6">
              <p className="text-lg text-slate-500 leading-relaxed font-medium">
                Africa's Trusted Digital Platform offers a referral reward
                program that allows clients to earn additional rewards by
                introducing new users to the platform.
              </p>
              <p className="text-lg text-slate-500 leading-relaxed font-medium">
                When someone registers using your unique referral link, you
                receive a{" "}
                <span className="text-[#1a4bdf] font-semibold">
                  5% referral reward
                </span>{" "}
                based on their successful participation on the platform.
              </p>
            </div>
          </div>

          <div className="w-[45%] flex justify-end">
            {/* 3D Graphic Placeholder */}
            {/* <img
              src="/img/new/background/reward.jpeg"
              alt="Referral Gift 5%"
              className="w-[350px] object-contain"
            /> */}
          </div>
        </div>

        {/* --- How It Works Card --- */}
        <div className="bg-white rounded-[2rem] p-10 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-100">
          <h2 className="text-2xl font-semibold text-slate-900 mb-8">
            How It Works
          </h2>

          <div className="flex items-start justify-between relative px-4">
            {/* Step 1 */}
            <div className="flex flex-col items-center text-center w-48 relative">
              <div className="w-20 h-20 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-6 relative shadow-sm border border-blue-50">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
                {/* Number Badge */}
                <div className="absolute -bottom-2 w-7 h-7 bg-[#1a4bdf] text-white text-xs font-semibold rounded-full flex items-center justify-center border-2 border-white">
                  1
                </div>
              </div>
              <p className="text-[15px] text-slate-500 font-medium leading-snug">
                Share your
                <br />
                personal referral link
              </p>
            </div>

            {/* Arrow */}
            <div className="pt-8 text-gray-300">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>

            {/* Step 2 */}
            <div className="flex flex-col items-center text-center w-48 relative">
              <div className="w-20 h-20 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-6 relative shadow-sm border border-blue-50">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5c-2.2 0-4 1.8-4 4v2"></path>
                  <circle cx="8.5" cy="7" r="4"></circle>
                  <line x1="20" y1="8" x2="20" y2="14"></line>
                  <line x1="23" y1="11" x2="17" y2="11"></line>
                </svg>
                <div className="absolute -bottom-2 w-7 h-7 bg-[#1a4bdf] text-white text-xs font-semibold rounded-full flex items-center justify-center border-2 border-white">
                  2
                </div>
              </div>
              <p className="text-[15px] text-slate-500 font-medium leading-snug">
                A new user registers
                <br />
                using your link
              </p>
            </div>

            {/* Arrow */}
            <div className="pt-8 text-gray-300">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>

            {/* Step 3 */}
            <div className="flex flex-col items-center text-center w-48 relative">
              <div className="w-20 h-20 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-6 relative shadow-sm border border-blue-50">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                  <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                  <polyline points="9 14 12 17 18 10"></polyline>
                </svg>
                <div className="absolute -bottom-2 w-7 h-7 bg-[#1a4bdf] text-white text-xs font-semibold rounded-full flex items-center justify-center border-2 border-white">
                  3
                </div>
              </div>
              <p className="text-[15px] text-slate-500 font-medium leading-snug">
                Once the registration
                <br />
                is completed, the
                <br />
                referral is recorded
              </p>
            </div>

            {/* Arrow */}
            <div className="pt-8 text-gray-300">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>

            {/* Step 4 */}
            <div className="flex flex-col items-center text-center w-48 relative">
              <div className="w-20 h-20 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-6 relative shadow-sm border border-blue-50">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 12 20 22 4 22 4 12"></polyline>
                  <rect x="2" y="7" width="20" height="5"></rect>
                  <line x1="12" y1="22" x2="12" y2="7"></line>
                  <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                  <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
                </svg>
                <div className="absolute -bottom-2 w-7 h-7 bg-[#1a4bdf] text-white text-xs font-semibold rounded-full flex items-center justify-center border-2 border-white">
                  4
                </div>
              </div>
              <p className="text-[15px] text-slate-500 font-medium leading-snug">
                You earn a{" "}
                <span className="text-[#1a4bdf] font-semibold">5%</span>
                <br />
                referral reward for
                <br />
                each successful referral
              </p>
            </div>
          </div>
        </div>

        {/* --- Referral Information Card --- */}
        {/* --- Referral Information Card --- */}
        <div className="bg-white rounded-[2rem] p-8 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-100 flex flex-col gap-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-[#1a4bdf] rounded-[1rem] flex items-center justify-center text-white shadow-md shadow-blue-600/20">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
              </svg>
            </div>
            <h2 className="text-[22px] font-semibold text-slate-900">
              Your Referral Information
            </h2>
          </div>

          <div>
            <label className="block text-[14px] text-slate-500 font-medium mb-3">
              Referral Link
            </label>
            <div className="flex gap-4">
              <input
                type="text"
                readOnly
                value={fullReferralLink}
                className="flex-1 bg-[#f8faff] border border-gray-200 rounded-[1rem] px-5 py-4 text-[15px] text-slate-800 focus:outline-none"
              />
              <button
                onClick={copyToClipboard}
                className="flex items-center gap-2 border border-[#dce5fc] bg-white hover:bg-blue-50 text-[#1a4bdf] px-8 py-4 rounded-[1rem] font-semibold text-[15px] transition-colors active:scale-95"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copy
              </button>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px w-full bg-gray-100 my-2"></div>

          {/* Total Referrals Row */}
          <div className="flex justify-between items-center px-2">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 bg-[#f0f4ff] rounded-xl flex items-center justify-center text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5c-2.2 0-4 1.8-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <p className="text-[16px] text-slate-500 font-medium">
                Total Referrals
              </p>
            </div>
            <p className="text-[28px] font-semibold text-[#1a4bdf]">
              {user?.referralCount || 0}
            </p>
          </div>
        </div>

        {/* --- Bottom Info Cards (Side by Side) --- */}
        <div className="flex gap-6 mt-4">
          {/* Card 1: Tracked Automatically */}
          <div className="flex-1 bg-white rounded-[1.5rem] p-6 shadow-[0_4px_20px_rgb(0,0,0,0.02)] border border-gray-100 flex items-center gap-5">
            <div className="w-12 h-12 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] shrink-0">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <polyline points="9 12 11 14 15 10"></polyline>
              </svg>
            </div>
            <p className="text-[13px] text-slate-500 font-medium leading-relaxed pr-4">
              Referral rewards are tracked automatically and reflected in your
              account dashboard.
            </p>
          </div>

          {/* Card 2: 24/7 Support */}
          <div className="flex-1 bg-white rounded-[1.5rem] p-6 shadow-[0_4px_20px_rgb(0,0,0,0.02)] border border-gray-100 flex items-center gap-5">
            <div className="w-12 h-12 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] shrink-0">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
              </svg>
            </div>
            <p className="text-[13px] text-slate-500 font-medium leading-relaxed pr-4">
              For any questions regarding the referral program, our 24/7
              WhatsApp support team is available to assist you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refer;
